import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { APIFactoryEndPoints } from "src/app/common/apifactory-end-points";
import { LocalStorageService } from "src/app/common/LocalStorageService";
import { OrderSummary } from "src/app/shared/models/ordersummary";
import { ProductsWithWebOrderOffers } from "src/app/shared/models/productswithweborderoffers";
import { PinDialogService } from "src/app/shared/services/pin-dialog.service";
import { ToastService } from "src/app/shared/services/toastr.service";
import { environment } from "src/environments/environment";
import { getWindow } from "ssr-window";
import { Product } from "../../../../shared/models/product";
import { ProductService } from "../../../../shared/services/product.service";
import { PinDialogComponent } from "../pin-dialog/pin-dialog.component";
import { ProductThumbnail } from "src/app/shared/models/product-thumbnail";
import { ProductDesignDialogComponent } from "../product-design-dialog/product-design-dialog.component";
import { WebUserInfo } from "src/app/shared/models/web-user-info";
import { CommonService } from "src/app/shared/services/CommonService";
import { ProductsWithStock } from "src/app/shared/models/products-with-stock";
import { HttpErrorResponse } from "@angular/common/http";
import { ViewOfferSetUpDto } from "src/app/shared/models/viewoffersetupdto";
import { OfferDetailsDialogComponent } from "../offer-details-dialog/offer-details-dialog.component";
import { BulkDiscountDto } from "src/app/shared/models/bulkdiscountdto";
import { OfferDialogComponent } from "../offer-dialog/offer-dialog.component";
import { StorePickupDialogComponent } from "../store-pickup-dialog/store-pickup-dialog.component";
import { GoogleCustomer } from "src/app/shared/models/googlecustomer";
import { WebOrderStockDetailsDto } from "src/app/shared/models/web-order-stock-details-dto";
import { WebOrderMinimumDateTimeSetup } from "src/app/shared/models/weborderminimumdatetimesetup";
import { WebOrderLocationSetup } from "src/app/shared/models/weborderlocationsetup";
import moment from "moment";
import { AppConfigService } from "src/app/shared/services/app-config.service";
import { SEOService } from 'src/app/common/SEOService';

@Component({
  selector: "app-product-detail",
  templateUrl: "./product-detail.component.html",
  styleUrls: ["./product-detail.component.scss"],
})
export class ProductDetailComponent implements OnInit, OnDestroy {
  private sub: any;
  product: Product;
  webUrl: string;
  pincode: any;
  productCode: number;
  productWithOffers: ProductsWithWebOrderOffers[] = [];

  orderSummary: OrderSummary = new OrderSummary();

  currentUrl: string;
  descStr: string = '';

  productThumbnails: ProductThumbnail[] = [];
  thumbNailImgList: string[] = [];
  productImgName: string = '';
  productVideoName: string = '';
  thumnnailType: string;
  sharingUrl: string = '';
  offerNames: string = '';
  designProducts: Product[] = [];
  productWithStock: ProductsWithStock[] = [];
  webOrderStockDetailsDto: WebOrderStockDetailsDto = new WebOrderStockDetailsDto();

  productOffer: Product;
  discountOffer: number;
  bulkDiscountOffer: BulkDiscountDto;
  offerObj: any;
  serverUrl: string;
  deliveryType: string;
  googleCustomer: GoogleCustomer;
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  storeLocation: WebOrderLocationSetup;
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];

  //Subscription
  private productSubcription: Subscription;
  private offerSubscription: Subscription;
  private getDesignSubscription: Subscription;
  private saveWebUserInfoSubscription: Subscription;
  private checkAllowStockSubscription: Subscription;
  private stockSubscription: Subscription;
  private productOfferSubscription: Subscription;
  private productDiscountSubscription: Subscription;
  private productBulkDiscountSubscription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private productService: ProductService,
    private toastrService: ToastService,
    private commonService: CommonService,
    private navRoute: Router,
    private apiFactory: APIFactoryEndPoints,
    private pincodeDialogService: PinDialogService,
    private seoService: SEOService,
    private appConfig: AppConfigService
  ) {
    this.serverUrl = this.apiFactory.getServerUrl;
    this.product = new Product();
  }

  ngOnInit() {
    this.currentUrl = getWindow().location.hostname
    this.webUrl = this.appConfig.setting.cartApiUrl;
    this.deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.storeLocation = JSON.parse(this.localStorage.getItem('pickup_location'));
    // this.sub = this.route.params.subscribe((params) => {
    //   const id = params?.["id"]; // (+) converts string 'id' to a number
    //   this.getProductDetail(id);
    // });
    this.sub = this.route.params.subscribe(params => {
      const slug = params['slug'];

      // extract code from last part
      const productCode = slug.split('-').pop();

      this.getProductDetail(productCode);
    });
    // this.getOfferDetail();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductDetail(id: number) {
    this.productCode = id;
    this.productSubcription = this.productService.getProductById(id).subscribe((data) => {
      this.product = data;

      if (this.product.description)
        this.descStr = "<li>" + this.product.description.replace('. ', ".<li>");

      this.sharingUrl = getWindow().location.origin + '/product' + '/' + this.product.product_Code;

      this.productImgName = this.product.product_Picture;
      this.thumnnailType = 'image';

      this.productThumbnails = [];
      let thumbnail: ProductThumbnail = new ProductThumbnail();
      thumbnail.fileName = this.product.product_Picture;
      thumbnail.fileType = "image";
      this.productThumbnails.push(thumbnail);
      this.product.productThumbnails.forEach(element => {
        this.productThumbnails.push(element);
      });
      console.log(data);
      this.getOfferDetail();
      this.getProductDeliveryTimeAndStockDetails();
      this.saveWebUserInfo();
      // update SEO meta for this product
      try {
        const title = `${this.product.product_Name} | 1 Bake Shop`;
        const desc = (this.product.description || this.product.productSubGroup?.productSubGroupName || '').toString();
        const imagePath = this.product.product_Picture || '';
        let imageUrl = imagePath;
        if (imagePath && !/^https?:\/\//i.test(imagePath)) {
          imageUrl = (this.webUrl ? this.webUrl.replace(/\/$/, '') : '') + '/' + imagePath.replace(/^\//, '');
        }
        const canonical = this.sharingUrl || getWindow().location.href;
        const tags: any[] = [
          { name: 'description', content: desc },
          { property: 'og:title', content: title },
          { property: 'og:description', content: desc },
          { property: 'og:image', content: imageUrl },
          { property: 'og:url', content: canonical },
          { name: 'twitter:card', content: 'summary_large_image' }
        ];
        this.seoService.updateTitle(title);
        this.seoService.updateTags(tags);
        this.seoService.setCanonicalURL(canonical);
        // inject Product JSON-LD for rich results
        try {
          const productJsonLd: any = {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": this.product.product_Name || this.product.productName,
            "image": imageUrl ? [imageUrl] : [],
            "description": desc || this.product.productSubGroup?.productSubGroupName || '',
            "sku": this.product.product_Code?.toString(),
            "brand": this.product.productSeller || undefined,
            "offers": {
              "@type": "Offer",
              "url": canonical,
              "priceCurrency": "INR",
              "price": (this.product.net_Sale_Price ?? this.product.sale_Price ?? this.product.productPrice ?? 0).toString(),
              "availability": (this.product.systemStock || this.product.manualStock) ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
            }
          };
          // add aggregateRating if available (use known fields, fall back safely)
          try {
            const ratingVal = (this.product.ratings ?? null);
            const ratingCount = ((this.product as any).reviewCount ?? (this.product as any).reviewsCount ?? (this.product as any).totalReviews ?? 0);
            if (ratingVal !== undefined && ratingVal !== null) {
              productJsonLd.aggregateRating = {
                "@type": "AggregateRating",
                "ratingValue": Number(ratingVal),
                "reviewCount": Number(ratingCount) || 0
              };
            }
          } catch (rErr) { }

          this.seoService.addJSONLD(productJsonLd, 'product-jsonld-' + (this.product.product_Code || '0'));
        } catch (jsonErr) {
          // ignore JSON-LD injection errors
        }
        try {
          const breadcrumb = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://1bakeshop.com/" },
              { "@type": "ListItem", "position": 2, "name": "Products", "item": "https://1bakeshop.com/products" },
              { "@type": "ListItem", "position": 3, "name": this.product.product_Name || this.product.productName, "item": canonical }
            ]
          };
          this.seoService.addJSONLD(breadcrumb, 'breadcrumb-jsonld-' + (this.product.product_Code || '0'));
        } catch (err) {
          // ignore
        }
      } catch (e) {
        // ignore non-browser env
      }
    });
  }

  getOfferDetail() {
    this.pincode = JSON.parse(this.localStorage.getItem("pincode_item"));
    console.log(this.pincode);

    let locId: number = JSON.parse(this.localStorage.getItem("location_code")) || 0;
    let type = this.deliveryType ? (this.deliveryType === 'storePickup' ? 'Pickup' : 'Delivery') : null;

    if (!type) {
      this.fetchOfferDetails(locId);
      return;
    }

    this.offerSubscription = this.productService.getOfferAllowFor(this.apiFactory.getOfferAllowFor, this.currentUrl, type)
      .subscribe((response: any) => {
        if (response.data === 'Not Available') {
          console.log("No offers available.");
          return;
        }

        locId = response.data === 'allowForWebsite' ? this.googleCustomer?.locationCode || 0 : response.data === 'allowForLocation'
          ? JSON.parse(this.localStorage.getItem('location_code')) || 0 : 0;

        this.fetchOfferDetails(locId);
      });
  }

  fetchOfferDetails(locId: number) {
    this.offerSubscription = this.productService.getOfferDetails(this.apiFactory.getOfferDetails, locId, [this.productCode], this.currentUrl)
      .subscribe((data) => {
        if (data.length === 0) return;

        this.productWithOffers = data;
        console.log(data);

        this.offerNames = this.productWithOffers[0].offerDetails.map(element => element.schemeName).join(', ');

        let offerData = this.productWithOffers.find(offer => offer.productCode === this.product.product_Code);
        if (offerData) {
          this.product.offerDetails = offerData.offerDetails;
          this.product.offers = offerData.offers;
        }
      });
  }

  openDialog(product: Product) {
    this.orderSummary.product = this.product;
    this.pincode = this.localStorage.getItem("pincode_item");
    this.orderSummary.pincode = this.pincode;
    console.log(this.orderSummary);
    this.pincodeDialogService.setOrderSummary(this.orderSummary);
    this.navRoute.navigate(["/address/address-app"]);
  }

  specialProductCodes: number[] = [901, 902, 743, 744, 746, 747, 745, 742];
  openDeliveryTypeDialog(product: Product, goToCartPage: boolean) {
    if (this.specialProductCodes.includes(Number(product.product_Code))) {
      this.toastrService.showWarningToast('Coming soon.');
      return;
    }
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log('Delivery Type:', deliveryType, 'Location ID:', locId);
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container'
      });

      dialogRef.afterClosed().subscribe(async result => {
        console.log(result)
        if (result) {
          await this.getProductDeliveryTimeAndStockDetails();
          const updatedProduct = this.product.product_Code === product.product_Code ? this.product : product;
          if (result === 'storePickup') {
            this.setStorePickup(updatedProduct, goToCartPage);
          } else if (result === 'delivery') {
            this.setDelivery(updatedProduct, goToCartPage);
            // this.openPinDialog(product, goToCartPage);
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        this.setStorePickup(product, goToCartPage);
      } else if (deliveryType === 'delivery') {
        this.setDelivery(product, goToCartPage);
        // this.openPinDialog(product, goToCartPage);
      }
    }
  }

  setStorePickup(product: Product, goToCartPage: boolean) {
    let selfLife = JSON.parse(this.localStorage.getItem('min_selflife'));
    if (product.shelf_Life_In_Hours >= selfLife) {
      product.cartProductType = 'Product';
      this.getProductWithStock(product, goToCartPage);
    } else {
      this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
    }
  }

  setDelivery(product: Product, goToCartPage: boolean) {
    let selfLife = JSON.parse(this.localStorage.getItem("min_selflife"));
    if (product.shelf_Life_In_Hours >= selfLife) {
      product.cartProductType = "Product";
      this.getProductWithStock(product, goToCartPage);
    } else {
      this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
    }
  }

  addToCart(product: Product) {
    product.cartProductType = "Product";
    // const products: Product[] = JSON.parse(this.localStorage.getItem("avct_item"));
    // if (products[0]?.cartProductType == 'Product' || products[0]?.cartProductType == null) {
    //   this.productService.addToCart(product);
    // }
    // else {
    //   this.toastrService.showErrorToast('Check out of Make To Order cart as Product item can not be added to Make To Order cart');
    // }
    this.productService.addToCart(product);
  }

  openPinDialog(product: Product, goToCartPage: boolean) {
    this.pincode = JSON.parse(this.localStorage.getItem("pincode_item"));
    console.log(this.pincode);
    if (this.pincode == null) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: "300px",
        data: product,
        panelClass: "pin-dialog-container",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.result == true) {
          // this.getGroupList();
          let selfLife = JSON.parse(this.localStorage.getItem("min_selflife"));
          if (product.shelf_Life_In_Hours >= selfLife) {
            product.cartProductType = "Product";
            // this.productService.addToCart(product);
            // this.getDesignBySubGroupAndUrl(product);
            this.getProductWithStock(product, goToCartPage);
          } else {
            this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
          }
        }
      });
    } else {
      let selfLife = JSON.parse(this.localStorage.getItem("min_selflife"));
      if (product.shelf_Life_In_Hours >= selfLife) {
        product.cartProductType = "Product";
        // this.productService.addToCart(product);
        // this.getDesignBySubGroupAndUrl(product);
        this.getProductWithStock(product, goToCartPage);
      } else {
        this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
      }
    }
  }

  getProductWithStock(product: Product, goToCartPage: boolean) {
    if (this.checkAllowStockSubscription) return;

    const locId = JSON.parse(this.localStorage.getItem('location_code'));
    const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';

    if (!locId) {
      this.toastrService.showErrorToast("Location can't place order");
      return;
    }

    this.checkAllowStockSubscription = this.productService
      .getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId, [product.product_Code], this.currentUrl, deliveryType)
      .subscribe({
        next: (data: WebOrderStockDetailsDto[]) => {
          this.checkAllowStockSubscription = null;

          const stockData = data?.[0]; // Get the stock data for this single product

          if (!stockData) {
            this.toastrService.showErrorToast(`${product.product_Name} stock data not found.`);
            return;
          }

          const minQty = product.minimum_Order_Quantity || 0;

          // Check Manual Stock first
          if (stockData.manualStockAllow) {
            if (stockData.manualStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.manualStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product, goToCartPage);
            return;
          }

          // Then check System Stock
          if (stockData.systemStockAllow) {
            if (stockData.systemStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.systemStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product, goToCartPage);
            return;
          }

          // If neither manual nor system stock check is allowed, proceed anyway
          this.getDesignBySubGroupAndUrl(product, goToCartPage);
        },
        error: (error: HttpErrorResponse) => {
          this.checkAllowStockSubscription = null;
          this.toastrService.showErrorToast('Something went wrong while checking stock.');
        }
      });
  }


  getProductWithStock1(product: Product, goToCartPage: boolean) {
    let locId = JSON.parse(this.localStorage.getItem("location_code"));
    if (locId) {
      this.checkAllowStockSubscription = this.productService.checkAllowStockByLocAndUrl(this.apiFactory.checkAllowStockByLocAndUrl, locId, this.currentUrl).subscribe((response: any) => {
        if (response.data) {
          if (product.product_Code) {
            this.stockSubscription = this.productService.getStockDetails(this.apiFactory.getStockDetails, [product.product_Code], locId).subscribe((data: any) => {
              this.productWithStock = data;

              var arr = this.productWithStock.filter((p) => p.product_Code == product.product_Code);
              if (arr.length != 0) {
                product.systemStock = arr[0].systemStock;
              }
              if (product.cartProductType == 'Product' && product.minimum_Order_Quantity > product.systemStock) {
                this.toastrService.showErrorToast(product.product_Name + " is out of stock, stock available " + product.systemStock);
                return;
              }
              this.getDesignBySubGroupAndUrl(product, goToCartPage);
            },
              (error: HttpErrorResponse) => {
                this.toastrService.showErrorToast("Something wrong..");
              });
          } else {

          }
        } else {
          this.getDesignBySubGroupAndUrl(product, goToCartPage);
        }
      },
        (error: HttpErrorResponse) => {
          this.toastrService.showErrorToast("Something wrong..");
        })
    } else {
      this.toastrService.showErrorToast("Location can't place order");
    }

  }

  getDesignBySubGroupAndUrl(product: Product, goToCartPage: boolean) {
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      if (goToCartPage) {
        this.productService.navigateToCart(product);
        return;
      }
      else {
        this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
        return;
      }
    }
    this.getDesignSubscription = this.productService.getWebOrderDesigns(this.apiFactory.getWebOrderDesignBySubgroupAndUrl, product.productSubGroup.refNo, this.currentUrl).subscribe((data) => {
      console.log(data);
      if (data.length > 0) {
        this.designProducts = data;
        const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];
        let designIndex = cartProducts.findIndex(e => e.designForProductCode === product.product_Code);
        if (designIndex >= 0) {
          this.designProducts.map(e => e.is_Default = false);
          this.designProducts.filter(item => item.product_Code == cartProducts[designIndex].product_Code).map(e => e.is_Default = true);
        }
        this.openDesignDialog(product, this.designProducts, goToCartPage);
      } else {
        if (product.offerDetails?.length > 0)
          this.openOfferDialog(product, null, goToCartPage)
        else {
          this.productService.addToCart(product);

          if (goToCartPage) {
            //Added to redirect to cart
            this.productService.navigateToCart(product);
          }
        }
        // this.toastrService.showErrorToast('No design available');
      }
    });
  }

  openDesignDialog(product: Product, designProducts: Product[], goToCartPage: boolean) {
    // let productList: Product[] = [];
    // productList.push(product);
    document.body.classList.add('dialog-open');
    const dialogRef = this.dialog.open(ProductDesignDialogComponent, {
      width: "430px",
      height: "410px",
      maxWidth: "90vw",
      data: designProducts,
      panelClass: "custom-dialog-container",
    });

    dialogRef.afterClosed().subscribe((result) => {
      document.body.classList.remove('dialog-open');
      if (result) {
        console.log(result.data)
        if (result?.data) {
          let design: Product = result?.data;
          design.designForProductCode = product.product_Code;
          design.cartProductType = "Product";
          // productList.push(design)
          if (product.offerDetails?.length > 0)
            this.openOfferDialog(product, design, goToCartPage)
          else {
            this.productService.addToCartDesign(product, design);

            if (goToCartPage) {
              //Added to redirect to cart
              this.productService.navigateToCart(product);
            }
          }
        } else if (result?.noDesign) {
          if (product.offerDetails?.length > 0)
            this.openOfferDialog(product, null, goToCartPage)
          else {
            this.productService.addToCart(product);

            if (goToCartPage) {
              //Added to redirect to cart
              this.productService.navigateToCart(product);
            }
          }
        }
      }
    });
  }

  openOfferDialog(product: Product, design: Product, goToCartPage: boolean) {
    console.log(product)
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      if (goToCartPage) {
        this.productService.navigateToCart(product);
        return;
      }
      else {
        this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
        return;
      }
    }
    let offers: ViewOfferSetUpDto[] = product.offerDetails;
    let appliedOfferId: string = product.offerId ? product.offerId : product.offerDetails[0].offerId;
    const dialogRef = this.dialog.open(OfferDialogComponent, {
      width: "500px",
      height: "300px",
      data: { offers, appliedOfferId },
    });

    dialogRef.afterClosed().subscribe((offerObj) => {
      console.log(offerObj);
      if (offerObj) {
        this.offerObj = offerObj;
        //conditions
        var orderQuantity;
        var freeByProductCode;
        var cartProductType;

        if (product) {
          // product.orderQuantity = offerObj.minQty;
          product.orderQuantity = Math.max(offerObj.minQty, offerObj.buyQty);
          console.log(product);
          orderQuantity = product.orderQuantity;
          freeByProductCode = product.product_Code;
          cartProductType = product.cartProductType;
          if (product.cartProductType == "Product") {
            product.basePremiumFlavourPrice = 0;
            product.premiumFlavourPrice = 0;
          }
        }
        console.log(product);

        // if (design) {
        //   this.productService.addToCartDesign(product, design);
        // }
        // else if (product.offerDetails[0].minQty > 1) {
        //   this.productService.addToCart(product);
        // }

        if (offerObj.schemeType == "Buy 1 get 1 Free" || offerObj.schemeType == "Buy X get Y Free") {
          this.productOfferSubscription = this.productService.getProductOfferDetails(this.apiFactory.productOfferDetails, offerObj.offerId, orderQuantity)
            .subscribe(
              (data) => {
                // offer processing
                this.productOffer = data;
                //set order qty as product QTY IN CART
                this.productOffer.product_Name = this.productOffer.product_Name.concat("(").concat(offerObj.schemeType).concat(")");
                // this.productOffer.orderQuantity = orderQuantity;
                const freeQty = Math.floor(orderQuantity / offerObj.buyQty) * offerObj.getQty;
                this.productOffer.orderQuantity = freeQty;
                this.productOffer.minimum_Order_Quantity = offerObj.minQty;
                // this.productOffer.net_Sale_Price = offerObj.productPriceForCustomer;
                this.productOffer.sale_Price = Number((this.productOffer.priceForCustomer / (1 + (this.productOffer.tax.taxRate / 100) + (this.productOffer.cess.cessRate / 100))));
                this.productOffer.discountAmt = 0;
                this.productOffer.discountRate = 0;
                var taxableAmt = this.productOffer.sale_Price - ((this.productOffer.sale_Price * this.productOffer.discountRate) / 100);
                var cess = this.productOffer.cess.cessRate;
                var tax = this.productOffer.tax.taxRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (this.productOffer.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (this.productOffer.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                this.productOffer.taxAmount = tot;
                this.productOffer.cgstAmt = cgst;
                this.productOffer.sgstAmt = sgst;
                this.productOffer.cessAmount = cessAmt;
                this.productOffer.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productOffer.cessRate = cess;
                this.productOffer.taxRate = tax;
                this.productOffer.freeProductNetSalePrice = offerObj.netSalePrice;
                this.productOffer.freeByProductCode = freeByProductCode;
                this.productOffer.cartProductType = cartProductType;
                this.productOffer.product_Type = this.productOffer.product_Type;
                this.productOffer.product_Unit = this.productOffer.product_Unit;
                this.productOffer.food_Type = this.productOffer.food_Type;
                this.productOffer.hsn_Code = this.productOffer.hsn_Code;
                this.productOffer.deliveryDate = product.deliveryDate;
                this.productOffer.timeSlotAvl = product.timeSlotAvl;
                this.productOffer.deliveryTime = product.deliveryTime;
                this.productOffer.deliveryLabel = product.deliveryLabel;

                // main product tax and net amount calculations
                product.discountAmt = 0;
                product.discountRate = 0;
                var taxableAmt = product.sale_Price - (product.sale_Price * 0) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                console.log(product);
                this.productService.addToCartWithOffer(product, this.productOffer, design);

                if (goToCartPage) {
                  //Added to redirect to cart
                  this.productService.navigateToCart(product);
                }
              },
              (err) => {
                if (err.error) {
                  this.toastrService.showErrorToast(err.error.message);
                }
              }
            );
        } else {
          if (offerObj.schemeType == "Buy x get x percent off") {
            this.productDiscountSubscription = this.productService.getProductDiscountDetails(this.apiFactory.productDiscountDetails, offerObj.offerId, orderQuantity)
              .subscribe(
                (data) => {
                  this.discountOffer = data;
                  product.discountAmt = (this.discountOffer / 100) * product.sale_Price;
                  product.discountRate = this.discountOffer;
                  var taxableAmt = product.sale_Price - (product.sale_Price * this.discountOffer) / 100;
                  taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                  var cess = product.cess.cessRate;
                  var cessAmt = (cess / 100) * taxableAmt;
                  var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var tot = cgst + sgst;
                  product.promotionOfferId = offerObj.offerId;
                  product.offerId = offerObj.offerId;
                  product.taxAmount = tot; //Tax Amount
                  product.cgstAmt = cgst;
                  product.sgstAmt = sgst;
                  product.cessAmount = cessAmt;
                  product.net_Sale_Price = taxableAmt + tot + cessAmt;
                  this.productService.addToCartWithOffer(product, null, design);

                  if (goToCartPage) {
                    //Added to redirect to cart
                    this.productService.navigateToCart(product);
                  }
                },
                (err) => {
                  if (err.error) {
                    this.toastrService.showErrorToast(err.error.message);
                  }
                }
              );
          } else {
            this.productBulkDiscountSubscription = this.productService.getProductBulkDiscountDetails(this.apiFactory.productBulkOfferDetails, offerObj.offerId)
              .subscribe((data) => {
                this.bulkDiscountOffer = data;
                product.discountAmt = (this.bulkDiscountOffer.discount / 100) * product.sale_Price;
                product.discountRate = this.bulkDiscountOffer.discount;
                var taxableAmt = product.sale_Price - (product.sale_Price * this.bulkDiscountOffer.discount) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productService.addToCartWithOffer(product, null, design);

                if (goToCartPage) {
                  //Added to redirect to cart
                  this.productService.navigateToCart(product);
                }
              });
          }
        }
      } else {
        // if (design)
        //   this.productService.addToCartDesign(product, design);
        // else
        //   this.productService.addToCart(product);
      }
    });
  }

  viewOfferDetail() {
    console.log(this.productWithOffers[0])
    let dialogRef = this.dialog.open(OfferDetailsDialogComponent, {
      width: '550px',
      minHeight: '18%',
      maxWidth: '90%',
      maxHeight: '70%',
      autoFocus: false,
      data: { offerData: this.productWithOffers[0]?.offerDetails }
    });

    dialogRef.afterClosed().subscribe(res => {

    })
  }

  onthumbNailimgClick(thumb: ProductThumbnail) {
    console.log(thumb)
    this.thumnnailType = thumb.fileType;
    if (thumb.fileType == 'image')
      this.productImgName = thumb.fileName;
    else
      this.productVideoName = thumb.fileName;

  }

  onShareClick(product: Product) {
    var url = 'https://web.whatsapp.com/send'
    var text = getWindow().location.origin + '/product' + '/' + product.product_Code;
    console.log(text)
    window.open(url + '?text=' + text)
  }

  saveWebUserInfo() {
    const localWebUserInfo: WebUserInfo = JSON.parse(this.localStorage.getItem("web_user_info"));
    const blockedIps = ['182.79.71.219', '182.79.71.218'];
    if (localWebUserInfo && localWebUserInfo.clientIp && !blockedIps.includes(localWebUserInfo.clientIp)) {
      localWebUserInfo.productCode = this.productCode;
      this.saveWebUserInfoSubscription = this.commonService.saveWebUserInfo(this.apiFactory.inserWebUserInfo, localWebUserInfo).subscribe((data) => {
        if (data) {
        }
      });
    }
  }

  getProductDeliveryTimeAndStockDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';
      const apiUrl = deliveryType === 'storePickup' ? this.apiFactory.getStoreMinimumDateTimeDetails : this.apiFactory.getWebOrderMinimumDateTimeDetails;
      const locId = JSON.parse(this.localStorage.getItem('location_code'));
      const minLocId = deliveryType === 'storePickup' ? locId : null;

      this.productService.getMinimumDateTimeDetails(apiUrl, this.currentUrl, minLocId).subscribe((data) => {
        if (data) {
          this.webOrderMinimumDateTimeList.deliveryTime = deliveryType === 'storePickup' ? data?.minOrderTime : data.deliveryTime;
          this.webOrderMinimumDateTimeList.maxDeliveryTime = deliveryType === 'storePickup' ? data?.maxOrderTime : data.maxDeliveryTime;

          const slotApiUrl = deliveryType === 'storePickup' ? this.apiFactory.getTimeSlotDetailsByUrlAndLocId : this.apiFactory.getTimeSlotDetailsByUrl;
          const slotLocId = deliveryType === 'storePickup' ? locId : null;

          this.productService.getTimeSlotList(slotApiUrl, this.currentUrl, slotLocId).subscribe((slotData) => {
            this.timeSlot2 = slotData.map((element) => [element.fromTime, element.toTime]);
            this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);

            var orderDuration = new Date();
            orderDuration.setHours(orderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]));
            orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]));

            let maxOrderDuration = moment().add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours")
              .add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes");

            // FETCH ALL STOCK DATA IN ONE CALL
            const productCodes = this.product.product_Code;
            this.productService.getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId ?? 0, [productCodes], this.currentUrl, deliveryType)
              .subscribe((stockList: WebOrderStockDetailsDto[]) => {


                const stockData = stockList.find(stock => stock.productCode === this.product.product_Code);
                const minQty = this.product.minimum_Order_Quantity || 0;

                let isAvailable = true; // Default to available

                if (stockData) {
                  if (stockData.manualStockAllow) {
                    // Check manual stock only
                    if (stockData.manualStock < minQty) {
                      isAvailable = false;
                    } else {
                      isAvailable = true;
                    }
                  } else if (stockData.systemStockAllow) {
                    // Manual not allowed, check system stock
                    if (stockData.systemStock < minQty) {
                      isAvailable = false;
                    } else {
                      isAvailable = true;
                    }
                  }
                  // If neither manual/system allow: keep isAvailable = true
                }

                this.product.outOfStock = !isAvailable;     // For blur + out of stock UI
                this.product.stockAvailable = isAvailable;  // For disabling Add to Cart

                // DELIVERY DATE + TIMESLOT LOGIC (same as before)
                let minOrderDate = new Date();
                minOrderDate.setDate(minOrderDate.getDate() + this.product.minimum_Order_Time);

                let greaterDate = orderDuration > minOrderDate ? orderDuration : minOrderDate;
                let todayDate = moment(greaterDate);

                this.product.deliveryDate = todayDate.format("YYYY-MM-DD");
                this.product.defaultDate = todayDate.format("YYYY-MM-DD");
                this.product.deliveryTime = todayDate.format("HH:mm");
                this.product.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
                this.product.maxDeliveryTime = maxOrderDuration.format("HH:mm");

                let totTime = todayDate.hours() * 60 + todayDate.minutes();
                this.product.timeSlotAvl = [];
                let matchedSlot = false;

                for (const e of this.timeSlot2) {
                  let fromSlotTime = Number(e[0].split(":")[0]) * 60 + Number(e[0].split(":")[1]);
                  if (totTime < fromSlotTime) {
                    let tSlot = `${e[0]}-${e[1]}`;
                    this.product.timeSlotAvl.push(tSlot);
                    if (!matchedSlot) {
                      this.product.deliveryTime = tSlot;
                      matchedSlot = true;
                    }
                  }
                }

                if (!matchedSlot) {
                  todayDate = todayDate.clone().add(1, 'day');
                  this.product.deliveryDate = todayDate.format("YYYY-MM-DD");
                  this.product.timeSlotAvl = this.timeSlot2.map(slot => `${slot[0]}-${slot[1]}`);
                  this.product.deliveryTime = this.product.timeSlotAvl[0];
                }

                const today = moment().startOf('day');
                const deliveryDay = todayDate.clone().startOf('day');

                if (deliveryDay.isSame(today, 'day')) {
                  this.product.deliveryLabel = 'Today';
                } else if (deliveryDay.diff(today, 'days') === 1) {
                  this.product.deliveryLabel = 'Tomorrow';
                } else {
                  this.product.deliveryLabel = deliveryDay.format('Do MMM');
                }

                console.log(this.product);
                resolve();
              }, reject);
          }, reject);
        } else {
          reject("Invalid delivery data");
        }
      }, reject);
    });
  }
}
